module.exports = __webpack_public_path__ + "images/skewness-04-faq-desktop.png";